module.exports = __webpack_public_path__ + "static/logo.01c47621.png";


//////////////////
// WEBPACK FOOTER
// /Users/evank/Documents/dev/kyle.ventures/src/content/logo.png
// module id = 634
// module chunks = 1